<template>
  <div :style="currentHeight">
    <div class="container">
      <!-- logo -->
      <div v-if="logoGuid" class="tenantLogoContainer">
        <img v-bind:src="logoPath + logoGuid" class="tenantLogo" alt="Logo" />
      </div>
      <img
        alt="WhatsApp logo"
        src="@/assets/WhatsApp_logo.png"
        class="logo"
        v-if="isLoadingDone"
      />
      <button class="button" v-if="isLoadingDone" @click="openUrl">open</button>
    </div>
    <div class="container-footer" @click="openPitchYouTab">
      <div class="powered-by-text" v-if="isLoadingDone">powered by</div>
      <img
        v-if="isLoadingDone"
        alt="Powered by PitchYou"
        src="@/assets/pitchyou_logo.png"
        class="footer-logo"
      />
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  ref,
  watch,
} from 'vue';
export default defineComponent({
  props: {
    isLoadingDone: Boolean,
    buttonUrl: String,
    logoGuid: String,
  },
  methods: {
    openPitchYouTab() {
      const url = 'https://www.pitchyou.de'; // URL, die geöffnet werden soll
      window.open(url, '_blank');
    },
  },
  setup(props) {
    const targetUrl = ref('');
    const useWindowOpen = ref(false);
    const screenHeight = ref(window.innerHeight);
    const logoPath = ref('/api/media/v1/logo/');

    const updateScreenHeight = () => {
      screenHeight.value = window.innerHeight;
    };

    const currentHeight = computed(() => {
      return {
        height: screenHeight.value + 'px',
      };
    });

    const openUrl = () => {
      if (props.buttonUrl) {
        if (useWindowOpen.value) {
          window.open(props.buttonUrl, '_blank');
        } else {
          window.location.href = props.buttonUrl;
        }
        useWindowOpen.value = !useWindowOpen.value;
      }
    };

    onMounted(() => {
      window.addEventListener('resize', updateScreenHeight);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', updateScreenHeight);
    });

    watch(
      () => props.buttonUrl,
      (newButtonUrl) => {
        targetUrl.value = newButtonUrl ?? '';
      }
    );

    return {
      openUrl,
      targetUrl,
      currentHeight,
      logoPath,
    };
  },
});
</script>
<style>
body,
html {
  height: 100%; /* Stellt sicher, dass der HTML- und Body-Tag den gesamten Viewport einnehmen */
  margin: 0; /* Entfernt Standardmargins */
  display: flex;
  flex-direction: column;
}
body {
  font-family: Calibri, sans-serif;
  background-color: #fcf5eb;
}

.container {
  background-color: #fcf5eb;
  height: 93vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: 0;
  flex: 1 0 auto;
}

.container-footer {
  background-color: #fcf5eb;
  height: 5vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  padding: 0;
  margin: 0;
  margin-top: auto;
  padding-bottom: 10px;
}
.container-footer div {
  margin-right: 10px; /* Abstand zwischen Text und Logo */
  /* Weitere Stile für den Text, falls nötig */
}

.footer-logo {
  max-width: 100px; /* Passen Sie die Größe nach Bedarf an */
  margin-top: auto; /* Schiebt das Logo an den unteren Rand */
  margin-bottom: 20px; /* Abstand vom unteren Rand */
}

.powered-by-text {
  color: #a22263; /* Farbe für 'powered by' Text */
}

.logo {
  max-width: 80%;
  margin: 30px auto 0;
  display: block;
}
.button {
  width: calc(
    100% - 40px
  ); /* 40px als Beispiel für den Gesamtabstand (20px auf jeder Seite) */

  /* Setzen Sie einen Abstand zu den Seiten */
  margin: 20px;
  /* Größere Schriftgröße und größere Abmessungen für den Button */
  font-size: 1.5em;
  padding: 10px 20px; /* Ändern Sie die Werte nach Bedarf */

  /* Abstand nach oben */
  margin-top: 20px; /* Ändern Sie den Wert nach Bedarf */

  /* Leicht abgerundete Ecken */
  border-radius: 10px; /* Ändern Sie den Wert für stärker oder schwächer abgerundete Ecken */

  /* Entfernen des Rahmens */
  border: none;

  /* Optional: Hintergrundfarbe und Textfarbe */
  background-color: #25d366; /* Blauer Hintergrund */
  color: #fcf5eb; /* Weißer Text */

  /* Weitere Stilisierung */
  cursor: pointer;
  transition: background-color 0.3s;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.tenantLogoContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fcf5eb;
}
.tenantLogo {
  max-width: 60%;
  max-height: 100px;
  object-fit: contain;
  width: auto;
  height: auto;
  display: block;
}
</style>
